import { ProjectionDetails } from '@interfaces/open-choice/projection-details.model';
import { RiskDescriptionEnum } from '@interfaces/open-choice/risk-quiz.enum';
import { Action, createReducer, on } from '@ngrx/store';
import {
  acceptDAOffer,
  gotDAOffer,
  rejectDAOffer,
  UpdateAccountId,
  UpdateDAAccountsToEnroll,
  UpdateDAComponentFailure,
  UpdateDraftID,
  UpdateEnrollPageHTML,
  UpdateOnboardingInitialized,
  UpdatePortfolioMatchResult,
} from '@store/actions/open-choice/open-choice.actions';

export interface OpenChoiceState {
  acceptedDAOffer: boolean;
  accountId: string;
  accountsToEnroll: ProjectionDetails | null;
  componentFailure: boolean;
  gotDAOffer: boolean;
  riskQuizResult: RiskDescriptionEnum | null;
  draftId: string;
  onboardingInitialized: boolean;
  enrollPageHTML: string | null;
}

export const initialState: OpenChoiceState = {
  acceptedDAOffer: false,
  accountId: '',
  accountsToEnroll: null,
  componentFailure: false,
  gotDAOffer: false,
  riskQuizResult: null,
  draftId: '',
  onboardingInitialized: false,
  enrollPageHTML: null,
};

const openChoiceReducer = createReducer(
  initialState,
  on(acceptDAOffer, (state) => {
    return {
      ...state,
      acceptedDAOffer: true,
    };
  }),
  on(rejectDAOffer, (state) => {
    return {
      ...state,
      acceptedDAOffer: false,
    };
  }),
  on(gotDAOffer, (state) => {
    return {
      ...state,
      gotDAOffer: true,
    };
  }),
  on(UpdateDAAccountsToEnroll, (state, { payload }) => {
    return {
      ...state,
      accountsToEnroll: payload,
    };
  }),
  on(UpdateAccountId, (state, { payload }) => {
    return {
      ...state,
      accountId: payload,
    };
  }),
  on(UpdateDAComponentFailure, (state, { payload }) => {
    return {
      ...state,
      componentFailure: payload,
    };
  }),
  on(UpdatePortfolioMatchResult, (state, { payload }) => ({
    ...state,
    riskQuizResult: payload,
  })),
  on(UpdateDraftID, (state, { payload }) => ({
    ...state,
    draftId: payload,
  })),
  on(UpdateOnboardingInitialized, (state, { payload }) => ({
    ...state,
    onboardingInitialized: payload,
  })),
  on(UpdateEnrollPageHTML, (state, { payload }) => ({
    ...state,
    enrollPageHTML: payload,
  })),
);

export function reducer(state: OpenChoiceState | undefined, action: Action) {
  return openChoiceReducer(state, action);
}

export const getDAAccountsToEnroll = (state: OpenChoiceState | null) =>
  state ? state.accountsToEnroll : null;

export const getDAComponentFailure = (state: OpenChoiceState | null) =>
  state ? state.componentFailure : null;

export const getAccountId = (state: OpenChoiceState | null) => (state ? state.accountId : null);

export const getPortfolioMatchResult = (state: OpenChoiceState | null) =>
  state ? state.riskQuizResult : null;

export const getdraftId = (state: OpenChoiceState | null) => (state ? state.draftId : null);

export const getOnboardingInitialized = (state: OpenChoiceState | null) =>
  state ? state.onboardingInitialized : false;

export const getEnrollPageHTML = (state: OpenChoiceState | null) =>
  state ? state.enrollPageHTML : null;
